import { AnyPrice, TranslatedString } from "@ct-react/core";

export enum AgeCategory {
  ADULT = "ADULT",
  BABY = "BABY",
  CHILD = "CHILD",
  EXEMPT = "EXEMPT",
  SENIOR = "SENIOR"
}

export enum CartOptionType {
  BENEFIT = "BENEFIT",
  CUSTOMER_CHARGE = "CUSTOMER_CHARGE",
  TOURIST_TAX = "TOURIST_TAX",
}

type CartOption = {
  __typename: string;
  optionId: string;
}

type GridItem = { price: AnyPrice };

type EditorialCartOption<K extends string, T> = CartOption & {
  title: TranslatedString;
  description?: TranslatedString;
  images?: string[];
  forceSelection: boolean;
  criteria: { [P in K]: T[] };
  grid: ({ [P in K]: T } & GridItem)[];
}

export type BenefitCartOption = EditorialCartOption<"quantity", number>;

export type TouristTaxCartOption = CartOption & {
  grid: ({ ageCategory: AgeCategory, ageRange: [ number, number ] } & GridItem)[];
}
export type AnyCartOption = BenefitCartOption | TouristTaxCartOption;
